import { SelectOption } from "shared/ui";

// Единицы ввода веса/объёма в формах. Это НЕ справочник MeasurementUnit с бэка —
// тот про decimalPlaces товара (кг/л/шт), а здесь подписи для поля.
export const MEASUREMENT_UNIT_OPTIONS: SelectOption[] = ["кг", "г", "мг", "л", "мл"].map(
    (unit) => ({ value: unit, label: unit })
);
